const events = {};

export function subscribe(event, callback) {
	if (!events[event]) {
		events[event] = [];
	}

	events[event].push(callback);

	return () => {
		events[event] = events[event].filter(cb => cb !== callback);
	};
}

export function unsubscribe(event, callback) {
	if (!events[event]) return;
	events[event] = events[event].filter(cb => cb !== callback);
}

export function publish(event, data) {
	if (!events[event] || events[event].length === 0) {
		return;
	}

	events[event].forEach(callback => callback(data));
}

export function unsubscribeAll(event) {
	if (events[event]) {
		delete events[event];
	}
}

